import React from "react";

function Amount({ formData }: any) {
  return (
    <tfoot className="bg-slate-50">
      <tr>
        <td colSpan={7} className="px-3 py-2 text-xs font-medium text-slate-600">Newly Added Charges</td>
        <td className="px-3 py-2 text-xs font-semibold text-slate-800">Rs {formData.total}</td>
        <td></td>
      </tr>
      <tr>
        <td colSpan={7} className={`px-3 py-2 text-xs font-medium ${formData.lastDue > 0 ? "text-red-600" : "text-emerald-600"}`}>
          {formData.lastDue > 0 ? "Previous Dues" : "Advance Received"}
        </td>
        <td className={`px-3 py-2 text-xs font-semibold ${formData.lastDue > 0 ? "text-red-600" : "text-emerald-600"}`}>
          Rs {Math.abs(formData.lastDue)}
        </td>
        <td></td>
      </tr>
      <tr className="bg-indigo-50">
        <td colSpan={7} className="px-3 py-2 text-xs font-bold text-indigo-700">Total Payable</td>
        <td className="px-3 py-2 text-sm font-bold text-indigo-700">Rs {formData.payable}</td>
        <td></td>
      </tr>
    </tfoot>
  );
}

export default Amount;
